import { AxiosResponse, Canceler } from 'axios';
import { IPaginationResponseDto, IReadingChallenge, IReadingChallengeCreator, IApiResult } from '../types';
import settings from '../settings';
import api from './base';

export function getReadingChallenges(): [Promise<AxiosResponse<IPaginationResponseDto<IReadingChallenge>>>, Canceler] {
  const uri = `${settings.getApiURI()}/event/v1/reading-challenges`;
  return api.getWithCancel(uri);
}

export function getReadingChallenge(readingChallengeId: number): [Promise<AxiosResponse<IReadingChallenge>>, Canceler] {
  const uri = `${settings.getApiURI()}/event/v1/reading-challenges/${readingChallengeId}`;
  return api.getWithCancel(uri);
}

export function saveReadingChallenge(payload: Partial<IReadingChallengeCreator>): Promise<AxiosResponse<IApiResult<IReadingChallenge>>> {
  const uri = `${settings.getApiURI()}/event/v1/reading-challenges`;
  return api.http.post(uri, payload);
}

export function editReadingChallenge(
  readingChallengeId: number,
  payload: Partial<IReadingChallengeCreator>,
): Promise<AxiosResponse<IApiResult<IReadingChallenge>>> {
  const uri = `${settings.getApiURI()}/event/v1/reading-challenges/${readingChallengeId}`;
  return api.http.patch(uri, payload);
}

export function deleteReadingChallenge(readingChallengeId: number): Promise<AxiosResponse<IApiResult<IReadingChallenge>>> {
  const uri = `${settings.getApiURI()}/event/v1/reading-challenges/${readingChallengeId}`;
  return api.http.delete(uri);
}
